import { render, staticRenderFns } from "./FooterArea.vue?vue&type=template&id=53e8a7ba&scoped=true"
import script from "./FooterArea.vue?vue&type=script&lang=js"
export * from "./FooterArea.vue?vue&type=script&lang=js"
import style0 from "./FooterArea.vue?vue&type=style&index=0&id=53e8a7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e8a7ba",
  null
  
)

export default component.exports